import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"

type Props = {
  companyId: string
  onSuccess?: () => void
}

export const useUpdateClusterSnapshotMutation = ({ companyId, onSuccess }: Props) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      clusterSnapshotId,
      canonicalTopicId,
    }: {
      clusterSnapshotId: string
      canonicalTopicId: string
    }) => {
      await axios.put(`/backoffice/canonicalTopics/${canonicalTopicId}/snapshot`, {
        companyId,
        clusterSnapshotId,
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["backofficeClusterSnapshots", companyId],
      })
      onSuccess?.()
    },
  })
}
